import { Outlet } from 'react-router-dom';
import { useAuth, useHasRole } from '@/hooks/use-auth';
import {
  Home,
  Users,
  UserCog,
  Heart,
  Calendar,
  CalendarDays,
  CalendarClock,
  ClipboardList,
  Settings,
  MessageSquare,
  MessageSquarePlus,
  BarChart3,
  Receipt,
} from 'lucide-react';
import { AppSidebar, NavItem, SidebarGroup } from '@/components/layout/app-sidebar';

const navItems: NavItem[] = [
  { id: 'dashboard', href: '/director', icon: Home, label: 'Dashboard' },
  { id: 'players', href: '/director/players', icon: Users, label: 'Players' },
  { id: 'coaches', href: '/director/coaches', icon: UserCog, label: 'Coaches' },
  { id: 'parents', href: '/director/parents', icon: Heart, label: 'Parents' },
  { id: 'invoices', href: '/director/invoices', icon: Receipt, label: 'Invoices' },
  { id: 'sessions', href: '/director/sessions', icon: Calendar, label: 'Sessions' },
  { id: 'calendar', href: '/director/calendar', icon: CalendarDays, label: 'Calendar' },
  { id: 'makeups', href: '/director/makeups', icon: CalendarClock, label: 'Makeups' },
  { id: 'attendance-report', href: '/director/attendance-report', icon: ClipboardList, label: 'Attendance' },
  { id: 'analytics', href: '/director/analytics', icon: BarChart3, label: 'Analytics' },
  { id: 'announcements', href: '/director/announcements', icon: MessageSquare, label: 'Announcements' },
  { id: 'settings', href: '/director/settings', icon: Settings, label: 'Settings' },
  { id: 'feedback', href: '/director/feedback', icon: MessageSquarePlus, label: 'Feedback' },
];

const sidebarGroups: SidebarGroup[] = [
  { label: 'Overview', ids: ['dashboard'] },
  { label: 'People', ids: ['players', 'coaches', 'parents'] },
  { label: 'Operations', ids: ['sessions', 'calendar', 'makeups', 'invoices', 'announcements'] },
  { label: 'Reports', ids: ['attendance-report', 'analytics'] },
  { label: 'Admin', ids: ['settings', 'feedback'] },
];

export default function DirectorLayout() {
  const { user, logout, isLoading } = useAuth();
  const isAlsoCoach = useHasRole('coach');

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-muted-foreground font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <AppSidebar
      navItems={navItems}
      sidebarGroups={sidebarGroups}
      bottomNavIds={['dashboard', 'players', 'sessions', 'invoices']}
      role="director"
      portalName="Director Portal"
      user={user}
      onLogout={logout}
      switchPortal={isAlsoCoach ? { label: 'Switch to Coach Portal', href: '/coach' } : undefined}
    >
      <Outlet />
    </AppSidebar>
  );
}
